import styled from '@emotion/styled'

import media from './../../../common/MediaQueries'
import { WithTheme } from './../../../setup/index'
import { iconBounceAnimation } from './../../../common/Animations'
import { BadgeStyled } from './../../atoms/Badge/styles'

const ProductInfoMediaStyled = styled.div`
  position: relative;
  height: 24.25rem;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: 15.5rem;
  min-width: 15.5rem;
  @media ${media.phone} {
    height: 24.25rem;
    min-width: 24.25rem;
  }
`

const ProductInfoMediaTitleStyled = styled.div<WithTheme>`
  text-align: center;
  text-transform: uppercase;
  font-weight: ${({ theme }) => theme.fontWeights.extrabold};
  z-index: 2;
`

const ProductInfoMediaContentStyled = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 15.5rem;

  @media ${media.phone} {
    width: 24.25rem;
    height: 100%;
  }
`

const ProductInfoMediaBackgroundStyled = styled.div`
  position: relative;

  .gatsby-image-wrapper {
    height: 100% !important;

    img {
      // position: static !important;
    }
  }
`

const ProductInfoMediaIconContainertStyled = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
`

const ProductInfoMediaIconListStyled = styled.ul`
  position: relative;
  width: 100%;
  height: 100%;

  > li {
    &:nth-of-type(1) {
      width: 3.125rem;
      height: 3.125rem;
      left: 3%;
      top: 7%;
      animation-delay: 0.1s;
      @media ${media.phone} {
        width: 5.625rem;
        height: 5.625rem;
      }
      @media ${media.tablet} {
        left: -16%;
        top: 11%;
      }
    }
    &:nth-of-type(2) {
      width: 3.625rem;
      height: 3.625rem;
      right: 0;
      top: -5%;
      animation-delay: 0.2s;
      @media ${media.phone} {
        width: 5.625rem;
        height: 5.625rem;
      }
      @media ${media.tablet} {
        right: -9%;
        top: 5%;
      }
    }
    &:nth-of-type(3) {
      width: 3.625rem;
      height: 3.625rem;
      bottom: 4%;
      left: 7%;
      animation-delay: 0.3s;
      @media ${media.phone} {
        width: 5.625rem;
        height: 5.625rem;
      }
      @media ${media.tablet} {
        bottom: -7%;
        left: 8%;
      }
    }
    &:nth-of-type(4) {
      width: 4rem;
      height: 4rem;
      bottom: -2%;
      right: 10%;
      animation-delay: 0.4s;
      @media ${media.phone} {
        width: 6.25rem;
        height: 6.25rem;
      }
      @media ${media.tablet} {
        bottom: -5%;
        right: 2%;
      }
    }
    &:nth-of-type(5) {
      width: 5.4375rem;
      height: 5.4375rem;
      top: -12%;
      left: 29%;
      animation-delay: 0.5s;
      @media ${media.phone} {
        width: 7.25rem;
        height: 7.25rem;
      }
      @media ${media.tablet} {
        top: -12%;
        left: 31%;
      }
    }
  }
`

const ProductInfoMediaIconListItemStyled = styled.li<WithTheme>`
  position: absolute;
  animation: ${iconBounceAnimation} 1s ease-in-out infinite;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0rem 0.1875rem 0.375rem rgba(0, 0, 0, 0.16);
  display: flex;
  justify-content: center;
  align-items: center;

  ${BadgeStyled} {
    width: 60%;
    height: 60%;
    @media ${media.phone} {
      width: 80%;
      height: 80%;
    }
  }
`

export {
  ProductInfoMediaStyled,
  ProductInfoMediaTitleStyled,
  ProductInfoMediaContentStyled,
  ProductInfoMediaBackgroundStyled,
  ProductInfoMediaIconListStyled,
  ProductInfoMediaIconListItemStyled,
  ProductInfoMediaIconContainertStyled
}
